import React from 'react';
import { Tag, TagType } from '@platform/witems';
import type { ChatRowLike, SpruceTranscriptAttachment } from '../logic/chatMessage';

interface Props {
  transcript: SpruceTranscriptAttachment<ChatRowLike> | null | undefined;
  when: string;
  noun?: 'voicemail' | 'call';
}

// A voicemail's or an answered call's transcript under its row: Spruce's summary shown, the transcript folded, plain text.
export default function SpruceTranscript({ transcript, when, noun = 'voicemail' }: Props) {
  if (!transcript) return null;
  if (transcript.kind === 'conflict') {
    return (
      <p className="detail1 spruce-transcript spruce-transcript--conflict" data-testid="spruce-transcript">
        {`Conflicting transcripts for this ${noun}. Open it in Spruce.`}
      </p>
    );
  }
  const summary = String(transcript.row.subject ?? '').trim();
  const body = String(transcript.row.body ?? '');
  return (
    <div className="spruce-transcript" data-testid="spruce-transcript">
      <div className="spruce-transcript__head">
        <span className="detail1 text-secondary">{summary ? 'AI summary · written by Spruce' : `No AI summary for this ${noun}.`}</span>
        <Tag type={TagType.MODERATE} label="speaker unverified" />
      </div>
      {summary && <p className="body2 spruce-transcript__text">{summary}</p>}
      <details className="disclosure spruce-transcript__full">
        <summary className="body2">
          Full transcript
          <span className="sr-only">{` of the ${noun}, ${when}`}</span>
          {' '}
          <span className="disclosure__chevron" aria-hidden="true">›</span>
        </summary>
        <p className="body2 spruce-transcript__text spruce-transcript__body">{body}</p>
      </details>
      <p className="detail1 text-secondary">
        Check the recording in Spruce before acting on it; confirm by calling back the number on file or in the app chat.
      </p>
    </div>
  );
}
